import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "mr-3" }
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeFilled = _resolveComponent("HomeFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Box = _resolveComponent("Box")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Document = _resolveComponent("Document")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_User = _resolveComponent("User")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "bg-white flex h-[100dvh] min-h-0 flex-col" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        class: "shadow-md",
        style: {"padding":"10px 6px","height":"52px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                class: "w-36",
                type: "primary",
                style: _normalizeStyle({ 
              backgroundColor: _ctx.defaultActive !== _ctx.ROUTES.DASHBOARD ? '#c2dbf0' : '',
              color: _ctx.defaultActive !== _ctx.ROUTES.DASHBOARD ? '#333333' : ''
            }),
                text: _ctx.defaultActive !== _ctx.ROUTES.DASHBOARD,
                bg: _ctx.defaultActive !== _ctx.ROUTES.DASHBOARD,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.DASHBOARD)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_HomeFilled)
                    ]),
                    _: 1
                  }),
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "ダッシュボード", -1))
                ]),
                _: 1
              }, 8, ["style", "text", "bg"]),
              _createVNode(_component_el_dropdown, { class: "ml-2" }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_ctx.currentUserRole !== _ctx.ROLE_VALUES.SPD)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.USAGE_CONFIRMATION)))
                          }, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode("申請登録", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.currentUserRole !== _ctx.ROLE_VALUES.SPD)
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.INVENTORY_HISTORY)))
                          }, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode("申請履歴", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_dropdown_item, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.ARRIVAL_STATUS)))
                      }, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode("入庫状況", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "w-8 md:w-32",
                    type: "info",
                    color: _ctx.inventoryPaths.includes(_ctx.defaultActive) ? '#000000' : '',
                    style: _normalizeStyle({ 
                backgroundColor: !_ctx.inventoryPaths.includes(_ctx.defaultActive) ? '#b7b7b7' : '',
                color: !_ctx.inventoryPaths.includes(_ctx.defaultActive) ? '#333333' : ''
              }),
                    text: !_ctx.inventoryPaths.includes(_ctx.defaultActive),
                    bg: !_ctx.inventoryPaths.includes(_ctx.defaultActive)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Box)
                        ]),
                        _: 1
                      }),
                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "hidden md:block" }, "申請管理", -1)),
                      _createVNode(_component_el_icon, { class: "el-icon--right hidden md:block" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowDown)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["color", "style", "text", "bg"])
                ]),
                _: 1
              }),
              (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM || _ctx.currentUserRole === _ctx.ROLE_VALUES.MANAGER)
                ? (_openBlock(), _createBlock(_component_el_dropdown, {
                    key: 0,
                    class: "ml-2 hidden md:block"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.REQUEST_REGISTER_CONSUMPTION)))
                          }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("申請一覧", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.REQUEST_LIST)))
                          }, {
                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                              _createTextVNode("発注確認", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.ORDER_CONFIRM_IN)))
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode("入庫確認", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "w-8 md:w-32",
                        type: "info",
                        color: _ctx.requestSheetPaths.includes(_ctx.defaultActive) ? '#000000' : '',
                        style: _normalizeStyle({ 
                backgroundColor: !_ctx.requestSheetPaths.includes(_ctx.defaultActive) ? '#b7b7b7' : '',
                color: !_ctx.requestSheetPaths.includes(_ctx.defaultActive) ? '#333333' : ''
              }),
                        text: !_ctx.requestSheetPaths.includes(_ctx.defaultActive),
                        bg: !_ctx.requestSheetPaths.includes(_ctx.defaultActive)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Edit)
                            ]),
                            _: 1
                          }),
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "hidden md:block" }, "申請書管理", -1)),
                          _createVNode(_component_el_icon, { class: "el-icon--right hidden md:block" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDown)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["color", "style", "text", "bg"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM || _ctx.currentUserRole === _ctx.ROLE_VALUES.SPD)
                ? (_openBlock(), _createBlock(_component_el_dropdown, {
                    key: 1,
                    class: "ml-2 hidden md:block"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.REQUEST_LIST_SPD)))
                          }, {
                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                              _createTextVNode("申請書一覧", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.ORDER_REGISTER_OUT)))
                          }, {
                            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                              _createTextVNode("発注表作成", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "w-8 md:w-28",
                        type: "info",
                        color: _ctx.orderSheetPaths.includes(_ctx.defaultActive) ? '#000000' : '',
                        style: _normalizeStyle({ 
                backgroundColor: !_ctx.orderSheetPaths.includes(_ctx.defaultActive) ? '#b7b7b7' : '',
                color: !_ctx.orderSheetPaths.includes(_ctx.defaultActive) ? '#333333' : ''
              }),
                        text: !_ctx.orderSheetPaths.includes(_ctx.defaultActive),
                        bg: !_ctx.orderSheetPaths.includes(_ctx.defaultActive)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "hidden md:block" }, "受注管理", -1)),
                          _createVNode(_component_el_icon, { class: "el-icon--right hidden md:block" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDown)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["color", "style", "text", "bg"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showSettingsMenu)
                ? (_openBlock(), _createBlock(_component_el_dropdown, {
                    key: 2,
                    class: "ml-2 hidden md:block"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM || _ctx.currentUserRole === _ctx.ROLE_VALUES.MANAGER)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 0,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.DEPARTMENT)))
                              }, {
                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                  _createTextVNode("署マスタ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM || _ctx.currentUserRole === _ctx.ROLE_VALUES.SPD || _ctx.currentUserRole === _ctx.ROLE_VALUES.MANAGER)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 1,
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.ITEM)))
                              }, {
                                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                  _createTextVNode("商品マスタ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM || _ctx.currentUserRole === _ctx.ROLE_VALUES.MANAGER)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 2,
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.USAGE_LIMIT)))
                              }, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createTextVNode("申請可能数マスタ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM )
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 3,
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.USER)))
                              }, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createTextVNode("ユーザーマスタ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.currentUserRole === _ctx.ROLE_VALUES.SYSTEM || _ctx.currentUserRole === _ctx.ROLE_VALUES.SPD)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 4,
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.MESSAGE)))
                              }, {
                                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                  _createTextVNode("メッセージマスタ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.canBudgetAdjustment)
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 5,
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goToPath(_ctx.ROUTES.BUDGET_ADJUSTMENT)))
                              }, {
                                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                  _createTextVNode("予算調整", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "w-8 md:w-28",
                        type: "info",
                        color: _ctx.settingPaths.includes(_ctx.defaultActive) ? '#000000' : '',
                        style: _normalizeStyle({ 
                backgroundColor: !_ctx.settingPaths.includes(_ctx.defaultActive) ? '#b7b7b7' : '',
                color: !_ctx.settingPaths.includes(_ctx.defaultActive) ? '#333333' : ''
              }),
                        text: !_ctx.settingPaths.includes(_ctx.defaultActive),
                        bg: !_ctx.settingPaths.includes(_ctx.defaultActive)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Setting)
                            ]),
                            _: 1
                          }),
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "hidden md:block" }, "設定", -1)),
                          _createVNode(_component_el_icon, { class: "el-icon--right hidden md:block" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDown)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["color", "style", "text", "bg"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.loginUserName), 1),
              _createVNode(_component_el_dropdown, null, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.handleChangePassword }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("パスワード変更", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_dropdown_item, { onClick: _ctx.handleLogout }, {
                        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                          _createTextVNode("ログアウト", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "w-10 h-10 p-0",
                    type: "info",
                    circle: "",
                    style: {"min-width":"40px","width":"40px","height":"40px","padding":"0","border-radius":"50%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "text-xl" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_User)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, {
        class: "min-h-0 flex-1 overflow-x-hidden overflow-y-auto",
        style: {"padding":"0"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.passwordDialogVisible,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.passwordDialogVisible) = $event)),
        title: "パスワード変更",
        width: "400px",
        "align-center": "",
        onClose: _ctx.handlePasswordDialogClose
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_el_button, {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.passwordDialogVisible = false))
            }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                _createTextVNode("キャンセル", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handlePasswordSubmit,
              loading: _ctx.passwordSubmitting
            }, {
              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                _createTextVNode(" 変更 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.passwordForm,
            rules: _ctx.passwordRules,
            ref: "passwordFormRef",
            "label-width": "140px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "現在のパスワード",
                prop: "oldPassword"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.passwordForm.oldPassword,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.passwordForm.oldPassword) = $event)),
                    type: "password",
                    placeholder: "現在のパスワードを入力",
                    "show-password": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "新しいパスワード",
                prop: "newPassword"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.passwordForm.newPassword,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.passwordForm.newPassword) = $event)),
                    type: "password",
                    placeholder: "新しいパスワードを入力（6文字以上）",
                    "show-password": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "新しいパスワード（確認）",
                prop: "confirmPassword"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.passwordForm.confirmPassword,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.passwordForm.confirmPassword) = $event)),
                    type: "password",
                    placeholder: "新しいパスワードを再入力",
                    "show-password": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ]),
    _: 1
  }))
}